import { LockerRoom } from '../types/lockerRoom';

/**
 * A changing room as the module's views write it: "omkl 3 / U12 drenge (16:00–17:45)" — the room,
 * its booking's text, and the changing room's own time (the team comes before the activity and
 * leaves after). `timeSeparator` is "." on the meeting-room sign, where times read "16.00".
 */
export function lockerRoomText(room: LockerRoom, timeSeparator = ':'): string {
  const name = [room.lockerRoomResourceName, room.displayText].filter((part) => !!part).join(' / ');
  const time = room.start && room.end ? ` (${clock(room.start, timeSeparator)}–${clock(room.end, timeSeparator)})` : '';
  return `${name}${time}`;
}

function clock(value: string, separator: string): string {
  const date = new Date(value);
  return `${String(date.getHours()).padStart(2, '0')}${separator}${String(date.getMinutes()).padStart(2, '0')}`;
}
